<template>
  <div class="grid-cell">
    <a
      :id="`gridProjectId${data.projectId}`"
      :href="viewProject"
      target="_parent _blank"
    >
      {{ data.projectId }}
    </a>
  </div>
</template>

<script>
import eInsightUrl from '@/constants/eInsightUrl'
export default {
  data () {
    return {
    }
  },
  computed: {
    viewProject () {
      return this.$store.getters.getEinsightUri + eInsightUrl.view(this.data.projectId)
    }
  }
}
</script>

<style lang="scss" scoped>
.grid-cell {
  overflow: hidden;
  text-overflow: ellipsis;
}
</style>
